import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

export interface Representative {
  value: string;
  label: string;
}

@Component({
  selector: "app-edit-sales-representative",
  templateUrl: "./edit-sales-representative.component.html",
  styleUrls: ["./edit-sales-representative.component.scss"],
})
export class EditSalesRepresentativeComponent {
  representatives: Representative[] = [
    // populate from API
    { value: "testusernewui", label: "testusernewui" },
  ];

  selectedRep: string = "testusernewui";

  constructor(
    private dialogRef: MatDialogRef<EditSalesRepresentativeComponent>,
  ) {}

  submit(): void {
    this.dialogRef.close(this.selectedRep);
  }

  close(): void {
    this.dialogRef.close();
  }
}
